import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { ButtonAction, FormOptions } from '@vendasta/vform';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { LspWrapperService } from '../lsp-wrapper.service';

@Component({
  selector: 'app-listing-sources',
  templateUrl: './listing-sources.component.html',
  styleUrls: ['./listing-sources.component.scss'],
})
export class ListingSourcesComponent {
  DateFormat = DateFormat;

  lspInfo$ = this.partnerId$.pipe(switchMap((partnerId) => this.lspService.getLspModelForPartner(partnerId)));
  lspProviders$ = this.partnerId$.pipe(switchMap((partnerId) => this.lspService.getLspProviders(partnerId)));

  lsFormOptions: FormOptions = {
    leftCustomButtons: [
      {
        label: this.translations.instant('CUSTOMIZE_PARTNER.SHARED.SAVE'),
        action: ButtonAction.SUBMIT,
        color: 'primary',
        disableWhenFormInvalidOrLoading: true,
      },
    ],
    formUrl: '/form/v1/partner/listing-sources',
    context: {},
  };

  constructor(
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
    private lspService: LspWrapperService,
    private translations: TranslateService,
  ) {}
}
